module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/duplex-browser.js
// module id = 345
// module chunks = 0